import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Options {
  flightCreditFee: number
  currency: string
}

function useFlightCreditTerms({ flightCreditFee, currency }: Options): Array<string> {
  const intl = useIntl()

  return useMemo(() => [
    intl.formatMessage({
      id: 'Jm7PERn3fX',
      defaultMessage: 'Fare rules of your new ticket will be the same as on your old ticket.',
      description: 'Flight credit rebooking term 1 - fare rules carry over',
    }),
    intl.formatMessage({
      id: 'HakmP+LKHM',
      defaultMessage: 'Airline fee - to be advised.',
      description: 'Flight credit rebooking term 2 - airline fee notice',
    }),
    intl.formatMessage(
      {
        id: 'qtVPsrAMR2',
        defaultMessage: 'Luxury Escapes reduced service fee - {dollarSign}{flightCreditFee} {currency} per person, per ticket.',
        description: 'Flight credit rebooking term 3 - service fee with dynamic amount and currency',
      },
      { dollarSign: '$', flightCreditFee, currency },
    ),
    intl.formatMessage({
      id: 'tfL52gGq7F',
      defaultMessage: 'New fare must be equal or higher.',
      description: 'Flight credit rebooking term 4 - fare value requirement',
    }),
    intl.formatMessage({
      id: 'hzmLMg5+1b',
      defaultMessage: 'Fare and/or tax difference (if any) will need to be paid by the customer.',
      description: 'Flight credit rebooking term 5 - fare difference responsibility',
    }),
    intl.formatMessage({
      id: 'YhXJeHDUdS',
      defaultMessage: 'Your new flight must depart from the same country as was shown on your original ticket.',
      description: 'Flight credit rebooking term 6 - departure country restriction',
    }),
    intl.formatMessage({
      id: '21sl9Ycru+',
      defaultMessage: 'Value of your ticket credit cannot be used on partner airlines (codeshare).',
      description: 'Flight credit rebooking term 7 - codeshare restriction',
    }),
    intl.formatMessage({
      id: 'oDe4yIi6Wi',
      defaultMessage: 'Value of your ticket credit must be used in a single transaction.',
      description: 'Flight credit rebooking term 8 - single transaction requirement',
    }),
    intl.formatMessage({
      id: 'mJxZ+6Ew/G',
      defaultMessage: 'Name on your new flight ticket must be the same as on your old ticket.',
      description: 'Flight credit rebooking term 9 - name must match in the flights section',
    }),
    intl.formatMessage({
      id: 'DZ2EU7QMbh',
      defaultMessage: 'Value of your ticket credit is non-refundable, non-transferrable, and non-combinable.',
      description: 'Flight credit rebooking term 10 - credit restrictions',
    }),
    intl.formatMessage({
      id: 'kRtipnc44k',
      defaultMessage: 'Your airline credit comes with a travel-by date. Please ensure to check this information on the credit confirmation that was previously sent to you.',
      description: 'Flight credit rebooking term 11 - travel-by date notice',
    }),
    intl.formatMessage({
      id: 'FbRf4v9WA1',
      defaultMessage: 'Airline credit conditions are subject to change without prior notice.',
      description: 'Flight credit rebooking term 12 - conditions may change notice',
    }),
  ], [intl, flightCreditFee, currency])
}

export default useFlightCreditTerms
